import { WikiInspectionType } from '../../api/jurisdiction';
import { apiSlice } from './apiSlice';

const api = apiSlice.injectEndpoints({
  endpoints: builder => ({
    addWikiInspection: builder.mutation({
      query: formData => {
        return {
          url: `wiki/wiki-jurisdiction-inspection/`,
          method: 'POST',
          body: formData,
        };
      },
    }),
    updateWikiInspection: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdiction-inspection/${arg.id}/`,
          method: 'PATCH',
          body: arg.formData,
        };
      },
    }),
    addWikiInspectionStep: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdiction-inspection-steps/`,
          method: 'POST',
          body: arg,
        };
      },
    }),
    getJurisdictionRequestResult: builder.query({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdiction-inspection-request-result/${arg.id}/get_request_result/`,
          method: 'GET',
        };
      },
    }),
    persistJurisdictionRequestResult: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdiction-inspection-request-result/${arg.id}/add_request_result/`,
          method: 'POST',
          body: arg.data,
        };
      },
    }),
    deleteJurisdictionRequestResult: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdiction-inspection-request-result/${arg.id}/`,
          method: 'DELETE',
        };
      },
    }),
  }),
});

export const {
  useAddWikiInspectionMutation,
  useUpdateWikiInspectionMutation,
  useAddWikiInspectionStepMutation,
  useGetJurisdictionRequestResultQuery,
  usePersistJurisdictionRequestResultMutation,
  useDeleteJurisdictionRequestResultMutation,
} = api;
